export default "__VITE_ASSET__b3e5836e__"